<template>
  <el-row>
    <el-col :span="15">
      <el-form-item :prop="prop[0]" :label="name">
        <el-select
          style="width: 100%"
          :value="value.length ? value[0] : ''"
          :placeholder="'请选择'"
          filterable
          :clearable="clearabled || false"
          @change="(val) => handleChange(val, true)"
        >
          <el-option
            v-for="item in options"
            :key="item[column.value || 'value']"
            :label="item[column.label || 'label']"
            :value="item[column.value || 'value']"
          ></el-option>
        </el-select>
      </el-form-item>
    </el-col>
    <el-col :span="1" style="text-align: center; line-height: 32px">&nbsp;</el-col>
    <el-col :span="8">
      <el-form-item label-width="0px" :prop="prop[1]">
        <input-number
          style="width: 100%"
          v-bind="$attrs"
          :clearable="clearabled || false"
          :placeholder="placeholder"
          @input="handleChange"
          :max="max"
          :value="value.length ? value[1] : ''"
        ></input-number>
      </el-form-item>
    </el-col>
  </el-row>
</template>
<script>
  import inputNumber from '@/components/form-item/input-number';
  export default {
    components: {
      inputNumber,
    },
    props: {
      prop: {
        // 可选，绑定form-item的prop
        type: Array,
        default: () => [],
      },
      name: {
        type: String,
        default: '',
      },
      value: {
        type: Array,
        default: () => [],
      },
      clearabled: {
        type: Boolean,
        default: false,
      },
      options: {
        type: Array,
        default: () => [],
      },
      placeholder: {
        type: String,
        default: '',
      },
      max: {
        type: [String, Number],
        default: () => '0',
      },
    },
    methods: {
      handleChange(val, select) {
        const value = this.value || [];
        if (select) {
          value[0] = val;
          if (!val) value[1] = '';
        } else {
          value[1] = val;
        }
        this.$emit('input', value);
      },
    },
  };
</script>
<style scoped></style>
